<div class="p-d-flex p-jc-center p-ai-center" style="height: 100vh">
	<div class="card_width">
		<p-card>
			<div class="p-d-flex p-jc-center p-ai-center">
				<img src="assets/images/ChatstasyCorpLogoAndSlogan-New.png" style="height: 30%;width: 70%;" alt="Chatstasy" />
			</div>
			<form class="form-login" (ngSubmit)="onSubmit(signInForm)" #signInForm="ngForm">
				<fieldset style="background: #ffffff;
				border: 1px solid #e6e8e8;
				border-radius: 5px;
				margin: 20px 0 20px 0;
				padding: 25px;
				position: relative;">
					<legend>
						Sign in to your account
					</legend>
					<p style="font-size: 15px;">
						Please enter your name and password to log in.
					</p>
					<div class="p-fluid">
						<div class="p-field">
							<span class="p-input-icon-left">
								<i class="pi pi-user" style="color: #007AFF;"></i>
								<input type="text" pInputText class="form-control" name="username"
									placeholder="Username" required autofocus ngModel />
							</span>
						</div>
						<div class="p-field">
							<span class="p-input-icon-left">
								<i class="pi pi-lock" style="color: #007AFF;"></i>
								<input pInputText type="password" class="form-control password" name="password"
									placeholder="Password" required ngModel />
								<a class="forgot" href="javascript:void(0)" routerLink="/forgot-password">
									I forgot my password
								</a>
							</span>
						</div>
					</div>

					<div>
						<div *ngIf="error" class="center mb-2">
							<label style="color: red;">
								{{error}}
							</label>
						</div>
						<div class="text-center">
							<p-button type="submit" label="Login" icon="pi pi-arrow-circle-right" iconPos="right"
								(click)="onSubmit(signInForm)" [disabled]="disabled"></p-button>
						</div>
					</div>

				</fieldset>
				<div *ngIf="isLoading" class="progressLayout">
					<div class="progressContainer">
						<p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
						</p-progressSpinner>
					</div>
				</div>
			</form>
			<div style="font-size: 11px;
				margin: 0 auto;
				padding: 10px 10px 0;
				text-align: center;">
				&copy;
				<span class="current-year"></span>
				<span style="font-weight: bold !important;text-transform: uppercase !important;"> Chatstasy</span>.
				<span>All rights reserved</span>
			</div>
		</p-card>
	</div>

</div>

<p-dialog header="Two Factor Authentication" [(visible)]="showTwoFactorAuth" [closable]="false" [modal]="true"
  [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [baseZIndex]="10000">
  <h4 style="text-align: center;"> Verify your identity to access your account.</h4>
  <p class="p-m-0" style="text-align: center;" *ngIf="userStatus">Please confirm access on your Chatstasy App</p>
  <p class="p-m-0" style="text-align: center;color: red;font-weight: 600;padding-bottom: 10px;" *ngIf="!userStatus">Access declined</p>
  <div style="text-align: center;" *ngIf="!userStatus">
    <button pButton type="button" label="OK" class="p-button-danger" (click)="showTwoFactorAuth = false; userStatus = true; pendingId = null"></button>
  </div>
  <div *ngIf="userStatus && pendingId" style="text-align: center; margin-top: 10px; font-size: 12px; color: #888;">
    <p>TEST ONLY &mdash; the real mobile approval isn't wired up yet.</p>
    <p>Request ID: <code>{{pendingId}}</code></p>
    <a href="/two-factor-approve?pendingId={{pendingId}}" target="_blank" rel="noopener">Open test approve/deny page</a>
  </div>
</p-dialog>